<template>
  <div class="container ingreso-manual">
    <div class="header">
      <div id="navigation-back" @click.prevent="back">
        <figure id="back-figure">
          <img src="../../static/img/back.png" alt="Volver">
        </figure>
      </div>
      <div id="navigation-home" @click.prevent="goInicio">
        <figure id="home-figure">
            <img src="../../static/img/home.png" alt="Inicio">
        </figure>
      </div>
    </div>
    <div class="section">
      <div class="logo">
        <figure>
          <img src="../assets/logo.png" alt="DIRECTV">
        </figure>
      </div>
      <div class="form">
        <b-form>
          <b-form-group>
            <b-form-input 
              id="documentoNumero"
              v-model.trim="$v.documentoNumero.$model" 
              :state="documentoNumeroValido"
              placeholder="Nro.DNI"
              @blur.native="resetValidations"
              type="text">
            </b-form-input>
            <b-form-invalid-feedback id="documentoNumeroFeedback">
              {{ documentoNumeroInvalidoMsj }}
            </b-form-invalid-feedback>          
          </b-form-group>
          <b-form-group>
            <b-form-input 
              id="apellido"
              v-model.trim="$v.apellido.$model" 
              :state="apellidoValido"
              placeholder="Apellido"
              @blur.native="resetValidations"
              type="text">
            </b-form-input>
            <b-form-invalid-feedback id="apellidoFeedback">
              {{ apellidoInvalidoMsj }}
            </b-form-invalid-feedback>          
          </b-form-group>
          <b-form-group>
            <b-form-input 
              id="nombre"
              v-model.trim="$v.nombre.$model" 
              :state="nombreValido"
              placeholder="Nombre"
              @blur.native="resetValidations"
              type="text">
            </b-form-input>
            <b-form-invalid-feedback id="nombreFeedback">
              {{ nombreInvalidoMsj }}
            </b-form-invalid-feedback>          
          </b-form-group>
          <b-form-group>
            <b-form-input 
              id="fechaNacimiento"
              v-model.trim="$v.fechaNacimiento.$model" 
              :state="fechaNacimientoValida"
              placeholder="Fecha Nacim."
              @blur.native="resetValidations"
              type="date">
            </b-form-input>
            <b-form-invalid-feedback id="fechaNacimientoFeedback">
              {{ fechaNacimientoInvalidaMsj }}
            </b-form-invalid-feedback>          
          </b-form-group>
          <b-form-group>
            <b-form-radio-group id="sexo" v-model="sexo">
              <b-form-radio class="radio" value="M">Masculino</b-form-radio>
              <b-form-radio class="radio" value="F">Femenino</b-form-radio>
              <b-form-radio class="radio" value="X">Otros</b-form-radio>
            </b-form-radio-group>
          </b-form-group>
          <b-button class="link"
            @click.prevent="save">ENVIAR</b-button>
        </b-form>
      </div>
    </div>
    <b-alert
      v-model="error"
      variant= "warning">
      <p>{{ errorMessage }}</p>
    </b-alert>    
  </div>
</template>

<script>
import { required, numeric, maxLength, minValue, maxValue } from 'vuelidate/lib/validators';

export default {
  data () {
    return {
      evento: null,
      eventoNombre: '',
      documentoNumero: '',
      apellido: '',
      nombre: '',
      fechaNacimiento: '',
      sexo: 'M',
      esCliente: true,

      documentoNumeroValido: null,
      apellidoValido: null,
      nombreValido: null,
      fechaNacimientoValida: null,
      documentoNumeroInvalidoMsj: '',
      apellidoInvalidoMsj: '',
      nombreInvalidoMsj: '',
      fechaNacimientoInvalidaMsj: '',

      error: false,
      errorMessage: ''
    }
  },
  created () {
    if (!this.$store.getters['settings/testing']) {
      if (!this.$store.getters['user/loggedIn']) {
        this.$router.push({ name: 'Login' });
      }
  
      this.evento = this.$store.getters['eventos/evento'];
      if (this.evento) {
        this.eventoNombre = this.evento.nombre;
      }
      if (!this.evento) {
        this.$router.push({ name: 'SeleccionEvento' });
      }
    }
  },
  methods: {
    resetValidations() {
      this.documentoNumeroValido = null;
      this.apellidoValido = null;
      this.nombreValido = null;
      this.fechaNacimientoValida = null;
      this.documentoNumeroInvalidoMsj = '';
      this.apellidoInvalidoMsj = '';
      this.nombreInvalidoMsj = '';
      this.fechaNacimientoInvalidaMsj = '';
    },
    save () {
      this.$v.$touch();

      this.documentoNumeroValido = null

      if (this.$v.documentoNumero.$error && !this.$v.documentoNumero.required) {
        this.documentoNumeroValido = false;
        this.documentoNumeroInvalidoMsj = 'Debe ingresar el DNI';
        return;
      }      
      if (this.$v.documentoNumero.$error && !this.$v.documentoNumero.numeric) {
        this.documentoNumeroValido = false;
        this.documentoNumeroInvalidoMsj = 'El DNI debe ser un valor numérico';
        return;
      }      
      if (this.$v.apellido.$error && !this.$v.apellido.required) {
        this.apellidoValido = false;
        this.apellidoInvalidoMsj = 'Debe ingresar el apellido';
        return;
      }      
      if (this.$v.nombre.$error && !this.$v.nombre.required) {
        this.nombreValido = false;
        this.nombreInvalidoMsj = 'Debe ingresar el nombre';
        return;
      }

      var participante = {
        documentoNumero: this.documentoNumero,
        apellido: this.apellido,
        nombre: this.nombre,
        fechaNacimiento: this.fechaNacimiento,
        sexo: this.sexo,
      }

    this.$store.dispatch('participante/setDatosParticipante', participante)
      .then(() => this.$router.push({ name: 'IngresoEsCliente' }))
      .catch( error => {
        this.error = true;
        this.errorMessage = error;
      });
    },
    back () {
      this.$router.go(-1)
    },
    goInicio () {
      this.$router.push({ name: 'Inicio' });
    }
  },
  validations: {
    documentoNumero: {
      required,
      numeric
    },
    apellido: {
      required
    },
    nombre: {
      required
    },
    fechaNacimiento: {
      required
    }
  },  
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/IngresoManual.vue